var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUploadFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#00205A",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.41 15.41L22.58 10.58C22.21 10.21 21.7 10 21.17 10H14C12.9 10 12.01 10.9 12.01 12L12 28C12 29.1 12.89 30 13.99 30H26C27.1 30 28 29.1 28 28V16.83C28 16.3 27.79 15.79 27.41 15.41ZM22.8 23H21V26C21 26.55 20.55 27 20 27C19.45 27 19 26.55 19 26V23H17.21C16.76 23 16.54 22.46 16.86 22.15L19.66 19.36C19.86 19.17 20.17 19.17 20.37 19.36L23.16 22.15C23.46 22.46 23.24 23 22.8 23ZM22 17C21.45 17 21 16.55 21 16V11.5L26.5 17H22Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadFilledIcon);
export default __webpack_public_path__ + "static/media/document_upload_filled_icon.b39fcbe4972a4e14fd755261e8dbdaf9.svg";
export { ForwardRef as ReactComponent };